﻿(function () {

    'use strict';
    var serviceId = 'repository.appointment';
    angular
        .module('app.services')
        .factory(serviceId, appointment);

    appointment.$inject = ['common', 'repository.abstract', '$http'];

    function appointment(common, abstractRepository, $http) {

        var config = common.config;
        function Ctor(mgr) {

            this.manager = mgr;

            this.getSearchScheduler = getSearchScheduler;
            this.getAppointmentsBySchedule = getAppointmentsBySchedule;
            this.getAppointments = getAppointments;
            this.getStatusByLanguage = getStatusByLanguage;
            this.getFilters = getFilters;
            this.getAppointmentByDate = getAppointmentByDate;
            this.getEquipmentsInAppointments = getEquipmentsInAppointments;
            this.getAppointmentById = getAppointmentById;
            this.getDriversByName = getDriversByName;
            this.getDriversByCriteria = getDriversByCriteria;
            this.getTruckersByName = getTruckersByName;
            this.GetAppointmentInLanguageByIdByYardByCriteria = GetAppointmentInLanguageByIdByYardByCriteria;
            this.getEquipmentsByCriteria = getEquipmentsByCriteria;
            this.getDepotOrdersByNo = getDepotOrdersByNo;
            this.getEquipmentSizeTypeIdsRestriction = getEquipmentSizeTypeIdsRestriction;

            this.getDepotOrderByRefDocNoCriteria = getDepotOrderByRefDocNoCriteria;
            this.getDepotOrderByRefDocNoOrEquipmentCriteria = getDepotOrderByRefDocNoOrEquipmentCriteria;
            this.getDocumentTypes = getDocumentTypes;
            this.getBusinessPartnerRestriction = getBusinessPartnerRestriction;
            this.getPlateRestriction = getPlateRestriction;

            this.saveDriver = saveDriver;
            this.createTruck = createTruck;
            this.saveAppointment = saveAppointment;
            this.saveAppointmentMultiple = saveAppointmentMultiple;
            this.saveAppointmentReschedule = saveAppointmentReschedule;
            this.editAppointment = editAppointment;
            this.cancelAppointment = cancelAppointment;
            this.getDeleteAppointment = getDeleteAppointment;

            this.getDepotOrderSearchSetting = getDepotOrderSearchSetting;
            this.getHoursForReschedule = getHoursForReschedule;
            this.getDriverRoleTypeDocuments = getDriverRoleTypeDocuments;
            this.getTruckDocumentTypes = getTruckDocumentTypes;
            this.getBusinessPartnerByName = getBusinessPartnerByName;
            this.getDepotOrderSummaryCounters = getDepotOrderSummaryCounters;
            this.getTruckerDriverPlateConfiguration = getTruckerDriverPlateConfiguration;
            this.getTruckerPlates = getTruckerPlates;
            this.getYards = getYards;
            this.changeYard = changeYard;
            this.getLeadTime = getLeadTime;
            this.getPrintAppointmentReport = getPrintAppointmentReport;
            this.getPrintAppointmentsConsolidationExcel = getPrintAppointmentsConsolidationExcel;
            this.yardScheduleHourDetailPersonalizeValidate = yardScheduleHourDetailPersonalizeValidate
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getSearchScheduler() {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetSearchScheduler');
        }

        function getDeleteAppointment() {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetDeleteAppointment');
        }

        function cancelAppointment(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/CancelAppointment', model);
        }

        function getAppointmentsBySchedule(model) {
            var verifica = common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentsBySchedule', model);

            return verifica;
        }

        function GetAppointmentInLanguageByIdByYardByCriteria(idAppointment, idYard, criteria) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentInLanguageByIdByYardByCriteria?idap=' + idAppointment + '&idyard=' + idYard + '&criteria=' + criteria);
        }

        function getHoursForReschedule(model) {

            model.TimeZone = new Date().getTimezoneOffset();
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetHoursForReschedule', model);
        }

        function getAppointmentById(appointmentId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentById?appointmentId=' + appointmentId);
        }

        function getAppointments(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentsConsolidation', model);
        }

        function getEquipmentsInAppointments(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetEquipmentsInAppointments', model);
        }

        function getStatusByLanguage() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentFilters');
        }

        function getFilters() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentFilters');
        }

        function getAppointmentByDate() {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentByDate');
        }

        function getOperationTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetAppointmentFilters');
        }

        function getTruckersByName(name) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetTruckersByName?criteria=' + name);
        }

        function getBusinessPartnerByName(name) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/getBusinessPartnerByName?criteria=' + name);
        }

        function getDriversByName(name, truckerId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetDriversByName?criteria=' + name + '&truckerId=' + truckerId);
        }

        function getDriversByName(name, truckerId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetDriversByName?criteria=' + name + '&truckerId=' + truckerId);
        }

        function getDriversByCriteria(model) {

            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetDriverByCriteria', model).then(function (data) {
                return data.BusinessPartner;
            }, function (err) {

            });

        }

        function getDepotOrdersByNo(request) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetDepotOrdersByNo', request);
        }

        function getDepotOrderByRefDocNoCriteria(criteria, doctypeId, actionType, yardId, operationTypeMovementCode, shipperId) {
            var request = {
                criteria: criteria, doctypeId: doctypeId, actionType: actionType, yardId: yardId,
                operationTypeMovementCode: operationTypeMovementCode, shipperId: shipperId 
            };
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetDepotOrderByRefDocNoCriteria', request);
        }

        function getDepotOrderByRefDocNoOrEquipmentCriteria(request) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetDepotOrderByRefDocNoOrEquipmentCriteria', request);
        }

        function getEquipmentsByCriteria(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/GetEquipmentsByCriteria', model);
        }

        function getDocumentTypes(operationType, actionType) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetDocumentTypes?operationType=' + operationType + '&actionType=' + actionType);
        }

        function getBusinessPartnerRestriction(businessPartnerId, roleType) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetBusinessPartnerRestriction?businessPartnerId=' + businessPartnerId + '&roleType=' + roleType);
        }

        function getPlateRestriction(truckPlate) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetPlateRestriction?truckPlate=' + truckPlate);
        }

        function getEquipmentSizeTypeIdsRestriction() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetEquipmentSizeTypeIds');
        }

        function editAppointment(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/UpdateAppointment', model);
        }

        function saveAppointment(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/CreateAppointment', model);
        }

        function saveAppointmentMultiple(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/CreateMultipleAppointment', model);
        }

        function saveDriver(model) {

            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/CreateDriver', model);
        }

        function createTruck(model) {

            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/CreateTruck', model);
        }

        function saveAppointmentReschedule(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'appointment/RescheduleAppointment', model);
        }

        function getDepotOrderSearchSetting(searchSetting) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetApplicationSettingByCreationCategory?categoryName=' + searchSetting);
        }

        function getDriverRoleTypeDocuments() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetDriverRoleTypeDocuments');
        }

        function getTruckDocumentTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetTruckDocumentTypes');
        }

        function getDepotOrderSummaryCounters(depotOrderId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetDepotOrderSummaryCounters?depotOrderId=' + depotOrderId);
        }

        function getTruckerDriverPlateConfiguration(onlyTruDri, onlyTruPl, actType) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetTruckerDriverPlateConfiguration?onlyTruckerDriver=' + onlyTruDri + '&onlyTruckerPlate=' + onlyTruPl + '&actionType=' + actType);
        }

        function getTruckerPlates(truckPlate, businessPartnerId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetTruckTable?criteria=' + truckPlate + '&businessPartnerId=' + businessPartnerId);
        }

        function getYards() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetYardList');
        }

        function changeYard(groupCode, username, securityrole, fromLoginWindow) {
            var uri = `${config.basePaths.Base_Path_Resources}appointment/changeBPyard?`;
            if (groupCode)
                uri = `${uri}groupCode=${groupCode}&`;
            if (username)
                uri = `${uri}userName=${username}&`;
            if (securityrole)
                uri = `${uri}securityRole=${securityrole}&`;
            if (fromLoginWindow)
                uri = `${uri}fromLoginWindow=${fromLoginWindow}&`;
            return common.httpGet(uri);
        }

        function getLeadTime(actionType, operationType) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/GetLeadTime?actionType=' + actionType + '&operationType=' + operationType);
        }
        function getPrintAppointmentReport(model, fileName) {
            return common.httpPostFile(config.basePaths.Base_Path_Resources + 'appointment/PrintAppointmentReport', model, fileName);
        }
        function getPrintAppointmentsConsolidationExcel(model, fileName) {
            return common.httpPostFile(config.basePaths.Base_Path_Resources + 'appointment/PrintAppointmentsConsolidationExcel', model, fileName);
        }
        function yardScheduleHourDetailPersonalizeValidate(depotOrderId, yardScheduleHourId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'appointment/YardScheduleHourDetailPersonalizeValidate?depotOrderId=' + depotOrderId + '&yardScheduleHourId=' + yardScheduleHourId);
        }
    }
})();